import styled from 'styled-components';

import { Button, TextButton } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';
import { space3XL, spaceL, spaceM, spaceS, spaceXL, spaceXS, spaceXXL } from '@xingternal/tokens';
import { space4XL } from '@xingternal/tokens/lib/generated/tokens';
import { BodyCopy, Headline } from '@xingternal/typography';

export const BackButton = styled(TextButton)`
  padding: 0;
  margin: ${spaceS} 0 ${spaceL};

  @media ${mediaConfined} {
    margin: ${spaceL} 0 ${spaceXXL};
  }
`;

export const Section = styled.section`
  margin-top: ${space3XL};
`;

export const SectionXtraSpace = styled.section`
  margin-top: ${space4XL};
`;

export const SectionHeadline = styled(Headline)`
  margin-bottom: ${spaceXL};
`;

export const FormFieldWrapper = styled.div`
  display: flex;

  &:not(:first-of-type) {
    margin-top: ${spaceXXL};
  }
`;

export const FirstFieldWrapper = styled.div`
  width: 100%;
  padding-right: ${spaceXS};

  @media ${mediaConfined} {
    padding-right: ${spaceM};
  }
`;

export const LastFieldWrapper = styled.div`
  width: 100%;
  padding-left: ${spaceXS};

  @media ${mediaConfined} {
    padding-left: ${spaceM};
  }
`;

export const FormFieldWrapperReactive = styled(FormFieldWrapper)`
  flex-direction: column;

  @media ${mediaConfined} {
    flex-direction: row;
  }
`;

export const FirstFieldWrapperReactive = styled.div`
  width: 100%;

  @media ${mediaConfined} {
    padding-right: ${spaceM};
  }
`;

export const LastFieldWrapperReactive = styled.div`
  margin-top: ${spaceXXL};
  width: 100%;

  @media ${mediaConfined} {
    margin-top: 0;
    padding-left: ${spaceM};
  }
`;

export const LogInLinkBodyCopy = styled(BodyCopy)`
  margin-top: ${spaceXL};
`;

export const LIPhoneWrapper = styled.div`
  display: flex;
  margin-top: ${spaceXL};
`;

export const CommentsSectionHeadline = styled(Headline)`
  margin-bottom: ${spaceL};
`;

export const CommentsBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceXL};
`;

export const PrivacySection = styled.section`
  margin-top: ${space3XL};

  p {
    display: inline;
  }
`;

export const CreateProfileConsent = styled(BodyCopy)`
  margin-top: ${spaceXL};
`;

export const ButtonsSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${spaceXXL} 0;

  @media ${mediaConfined} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const SubmitButton = styled(Button)`
  @media ${mediaConfined} {
    margin-right: ${spaceL};
  }
`;

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;

  &:disabled {
    button {
      pointer-events: none;
    }
  }
`;
